import { addSideEffects } from '@poa/state';
import { fetchWallet } from './wallet.actions';

addSideEffects(fetchWallet, async (payload, { actions, env }) => {
  try {
    actions.walletActions.fetchWalletSuccess([]);
  } catch (e) {
    console.error(e);
    actions.walletActions.fetchWalletFailed();
    throw e;
  }
});
